'use client';

import { CheckableElementProps } from '@/interfaces/basicForm';
import { checkedValue } from '@/utils/helper';
import { useEffect, useState } from 'react';

export const BasicRadio = ({
  name,
  value,
  label,
  className = '',
  onChange = () => {},
  isChecked = false,
  selectedValues,
  isDisable,
  labelIcon,
  onClick = () => {},
}: CheckableElementProps) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(checkedValue(selectedValues, value));
  }, [selectedValues, value]);
  return (
    <label className={`radio ${checked ? 'checked' : ''} ${className}`}>
      <input
        disabled={isDisable}
        checked={isChecked}
        type="radio"
        className={`form-field cursor-pointer`}
        {...{ name, value }}
        onChange={(e) => {
          setChecked(e.target.checked);
          onChange(e);
        }}
        onClick={onClick}
      />
      <span className="flex items-center gap-2">
        {label}
        {labelIcon && <span className="flex items-center">{labelIcon}</span>}
      </span>
    </label>
  );
};
